<label
  class="app-label d-inline-block align-items-center text-break"
  [class.app-label--disabled]="disabled()"
  [class.app-label--small]="smallText()"
  [class.app-label--red]="redText()"
  [class.mb-0]="noBottomMargin()"
  [for]="idFor()"
>
  <ng-content></ng-content>
  @if (showRequiredMarker()) {
    <span class="required-marker">&nbsp;*</span>
  }
</label>
